import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    fetchCompanyInfo,
    updateCompanyInfoById
} from "../../../../api/menu/master-files/company-info/actions";
import SearchSelect from "../../../common/SearchSelect";

class AccountingExportHeader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            batchOptions: [],
        };

        this.fillBatchOptions = this.fillBatchOptions.bind(this);
    }
    fillBatchOptions(props) {
        const batchOptions = [];
        if (Array.isArray(props.batches) && props.batches.length > 0) {
            batchOptions.push({
                value: 0,
                label: 0,
            });
            props.batches.map((item) => {
                batchOptions.push({
                    value: item,
                    label: item,
                });
            });
        }
        this.setState({
            batchOptions
        });
    }

    componentDidMount() {
        this.fillBatchOptions(this.props);
    }

    componentWillReceiveProps (nextProps) {
        this.fillBatchOptions(nextProps);
    }

    render() {
        console.log("tjis.props", this.props.batches)
        const { companyInfo, batchNumber } = this.props;
        // const lastBatchNumber = companyInfo ? companyInfo.nextBatchNumber - 1 : null;
        const currentBatch = this.state.batchOptions.find(item => item.value === batchNumber) || { label: 0, value: 0 };

        return (
            <div className="row pt-2 pb-3">
                <div className="col-2"/>
                <div className="col-2">
                    <div
                        className="form-group form-inline d-flex justify-content-end mb-2 w-100"
                        style={{ position: "absolute", top: "-38px" }}
                    >
                            <label className="mr-3">Batch Number</label>
                        <div className="batch-select">
                            <SearchSelect
                            className="custom-react-select"
                            options={this.state.batchOptions}
                            isLoading={false}
                            isClearable={false}
                            isSearchable={true}
                            value={currentBatch}
                            onChange={this.props.setBatchNumber}
                        />
                        </div>

                        <Button
                            className="ml-2"
                            variant="success"
                            style={{ zIndex: 2 }}
                            onClick={this.props.handleLoad}
                        >
                            Load
                        </Button>
                    </div>
                </div>
                {/* <div className="col-2 d-flex"> */}
                {/*     { */}
                {/*         lastBatchNumber ? <p style={{ zIndex: -1, position: "absolute", top: "-32px", paddingLeft: "32px" }}> */}
                {/*             {`Last Batch Number: ${lastBatchNumber}`} */}
                {/*         </p> : null */}
                {/*     } */}
                {/* </div> */}
                <div className="col-6 d-flex justify-content-end">
                    <p style={{ zIndex: -1, position: "absolute", top: "-32px" }}>
                        {this.props.selectedText}
                    </p>
                </div>
            </div>
        );
    }
}

AccountingExportHeader.propTypes = {
    setBatchNumber: PropTypes.func.isRequired,
    handleLoad: PropTypes.func.isRequired,
    selectedText: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
    //companyInfo: state.companyInfo.companyInfo,
    loading: state.companyInfo.loading
});

const mapStateToDispatch = dispatch => ({
    //fetchCompanyInfo: bindActionCreators(fetchCompanyInfo, dispatch),
    updateCompanyInfoById: bindActionCreators(updateCompanyInfoById, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(AccountingExportHeader);
